// extracted by mini-css-extract-plugin
export default {"list":"list--QLmym","item":"item--ySEJ0","paginaton":"paginaton--zrXgt","button":"button--GyLhv","loadingBox":"loadingBox--jzwdi","status":"status--ZbOeC","text":"text--nluoI"};